import React from 'react';
import ChamadoHeader from './ChamadoHeader';
import ChamadoTabs from './ChamadoTabs';
import ChamadoDescription from './ChamadoDescription';
import ChamadoEditor from './ChamadoEditor';
import ChamadoTimeline from './ChamadoTimeline';
import ChamadoSidebar from './ChamadoSidebar';
import './ChamadoPage.css';

function ChamadoPage({
    satNum,
    titulo,
    subtitulo,
    solicitanteNome,
    atendenteNome,
    statusAtual,
    statusParaSelect,
    getNomeStatus,
    onStatusChange,
    prioridadeBadge,
    sprintId,
    sprintNome,
    tipoNome,
    abaAtiva,
    onAbaChange,
    descriptionContent,
    editorProps,
    timelineEventos,
    onDeleteHistorico,
    sidebarProps,
    anexosCard,
    anexosCardRef,
    resumoIABar,
    resumoActionsRight,
    iaHabilitada,
    onSugerirPrioridade,
    prioridadeLoading,
    onAlterarTipo,
    chamadoEncerrado,
    ocultarEditor,
}) {
    const statusNome = getNomeStatus ? getNomeStatus(statusAtual) : '';

    return (
        <div className="chamado-page">
            <div className="chamado-page-main">
                <ChamadoHeader
                    titulo={titulo}
                    subtitulo={subtitulo}
                    solicitanteNome={solicitanteNome}
                    statusNome={statusNome}
                    atendenteNome={atendenteNome}
                    prioridadeBadge={prioridadeBadge}
                    sprintNome={sprintNome}
                    sprintId={sprintId}
                    tipoNome={tipoNome}
                    iaHabilitada={iaHabilitada}
                    onSugerirPrioridade={onSugerirPrioridade}
                    prioridadeLoading={prioridadeLoading}
                    onAlterarTipo={onAlterarTipo}
                    actionsRight={resumoActionsRight}
                />
                {resumoIABar}
                <div className="chamado-card-wrap">
                    <ChamadoTabs abaAtiva={abaAtiva} onAbaChange={onAbaChange} />
                    <ChamadoDescription className={abaAtiva === 'DESENVOLVIMENTO' || abaAtiva === 'HORAS' ? 'chamado-description-card--embedded' : ''}>{descriptionContent}</ChamadoDescription>
                </div>
                {!ocultarEditor && (
                <ChamadoEditor
                    value={editorProps.value}
                    onChange={editorProps.onChange}
                    onInserir={editorProps.onInserir}
                    onAnexar={editorProps.onAnexar}
                    marcado={editorProps.marcado}
                    onMarcadoChange={editorProps.onMarcadoChange}
                    comentarioInterno={editorProps.comentarioInterno}
                    onComentarioInternoChange={editorProps.onComentarioInternoChange}
                    iaHabilitada={editorProps.iaHabilitada}
                    onSugerirResposta={editorProps.onSugerirResposta}
                    onReverResposta={editorProps.onReverResposta}
                    onSugerirProximosPassos={editorProps.onSugerirProximosPassos}
                    sugestaoRespostaLoading={editorProps.sugestaoRespostaLoading}
                    reverRespostaLoading={editorProps.reverRespostaLoading}
                    proximosPassosLoading={editorProps.proximosPassosLoading}
                    onAtualizar={editorProps.onAtualizar}
                />
                )}
                <ChamadoTimeline eventos={timelineEventos} onDelete={onDeleteHistorico} />
            </div>
            <ChamadoSidebar
                satNum={satNum}
                statusAtual={sidebarProps.statusAtual}
                statusParaSelect={sidebarProps.statusParaSelect}
                getNomeStatus={sidebarProps.getNomeStatus}
                onStatusChange={sidebarProps.onStatusChange}
                sprintId={sidebarProps.sprintId}
                sprintNome={sidebarProps.sprintNome}
                estimativaHoras={sidebarProps.estimativaHoras}
                tempoTrabalhadoTexto={sidebarProps.tempoTrabalhadoTexto}
                tempoAnaliseTexto={sidebarProps.tempoAnaliseTexto}
                tempoTesteTexto={sidebarProps.tempoTesteTexto}
                emPeriodoAberto={sidebarProps.emPeriodoAberto}
                emPeriodoAbertoAnalise={sidebarProps.emPeriodoAbertoAnalise}
                emPeriodoAbertoTeste={sidebarProps.emPeriodoAbertoTeste}
                tempoTrabalhadoMinutos={sidebarProps.tempoTrabalhadoMinutos}
                usaSprint={sidebarProps.usaSprint}
                atendenteNome={sidebarProps.atendenteNome}
                opcoesColaboradores={sidebarProps.opcoesColaboradores}
                novoResponsavelId={sidebarProps.novoResponsavelId}
                onNovoResponsavelChange={sidebarProps.onNovoResponsavelChange}
                onAtribuirAtendente={sidebarProps.onAtribuirAtendente}
                salvandoAtribuicaoAtendente={sidebarProps.salvandoAtribuicaoAtendente}
                carregandoOpcoesColaboradores={sidebarProps.carregandoOpcoesColaboradores}
                colaboradores={sidebarProps.colaboradores}
                carregandoColaboradores={sidebarProps.carregandoColaboradores}
                novoColaboradorId={sidebarProps.novoColaboradorId}
                onNovoColaboradorChange={sidebarProps.onNovoColaboradorChange}
                onAdicionarColaborador={sidebarProps.onAdicionarColaborador}
                onRemoverColaborador={sidebarProps.onRemoverColaborador}
                salvandoColaborador={sidebarProps.salvandoColaborador}
                onIniciarAtendimento={sidebarProps.onIniciarAtendimento}
                onPausar={sidebarProps.onPausar}
                onConcluir={sidebarProps.onConcluir}
                chamadoEncerrado={chamadoEncerrado}
                onRetomarAtendimento={sidebarProps.onRetomarAtendimento}
                retomarLoading={sidebarProps.retomarLoading}
                anexosCard={anexosCard}
                anexosCardRef={anexosCardRef}
            />
        </div>
    );
}

export default ChamadoPage;
